import React, { ReactNode } from 'react';
import NextLink, { LinkProps as NextLinkProps } from 'next/link';

interface LinkProps extends NextLinkProps {
  children: ReactNode;
}

const Link: React.FC<LinkProps> = ({ href, children }) => (
  <NextLink href={href} className="text-black text-base font-bold" passHref>
    {children}
  </NextLink>
);

export default Link;
